export default "__VITE_ASSET__CYZL9DhK__"